var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoldova(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_384_1655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0.000488281V24H24V0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99983 0H0V24H7.99983V0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9998 0H16V24H23.9998V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1305 10.0808H12.9784C12.9784 9.54054 12.5404 9.10254 12.0001 9.10254C11.4598 9.10254 11.0218 9.54054 11.0218 10.0808H8.86963C8.86963 10.6127 9.33299 11.044 9.86488 11.044H9.83286C9.83286 11.576 10.2641 12.0072 10.7961 12.0072C10.7961 12.4782 11.1343 12.8696 11.5811 12.9533L10.8222 14.6669C11.1858 14.8147 11.5833 14.8969 12.0001 14.8969C12.4169 14.8969 12.8144 14.8147 13.1781 14.6669L12.4191 12.9533C12.8659 12.8696 13.2041 12.4782 13.2041 12.0072C13.7361 12.0072 14.1673 11.576 14.1673 11.044H14.1352C14.6672 11.044 15.1305 10.6128 15.1305 10.0808Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 11.4131L10.728 12.0001V13.1739L11.9998 13.9566L13.2715 13.1739V12.0001L11.9998 11.4131Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2715 10.8262H10.728V12.0001H13.2715V10.8262Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_384_1655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoldova);
export default __webpack_public_path__ + "static/media/moldova.41da5005332cc95a2f3b47297edb4f8b.svg";
export { ForwardRef as ReactComponent };